module.exports = __webpack_public_path__ + "media/images/microphone-128a892b84bcf3147b9d0cf587a4fc50.png";